import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import { Link } from 'react-router-dom';

import { NAV_BG, AMBER } from '../theme';

const Section = ({ title, children }) => (
    <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ fontFamily: '"Outfit", sans-serif', fontWeight: 700, color: NAV_BG, mb: 1.5 }}>
            {title}
        </Typography>
        <Typography sx={{ fontFamily: '"Outfit", sans-serif', fontSize: '0.95rem', color: '#475569', lineHeight: 1.8 }}>
            {children}
        </Typography>
    </Box>
);

const TermsPage = () => (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f1f5f9', py: 6 }}>
        <Container maxWidth="md">
            <Box sx={{ backgroundColor: 'white', borderRadius: '18px', border: '1px solid #e2e8f0', boxShadow: '0 8px 40px rgba(15,45,94,0.08)', p: { xs: 3, md: 6 } }}>

                {/* Header */}
                <Box sx={{ mb: 4 }}>
                    <Typography sx={{ fontFamily: '"Outfit", sans-serif', fontWeight: 800, fontSize: '2rem', color: NAV_BG, mb: 1 }}>
                        Terms & Conditions
                    </Typography>
                    <Typography sx={{ fontFamily: '"Outfit", sans-serif', fontSize: '0.85rem', color: '#94a3b8' }}>
                        Last updated: March 2026
                    </Typography>
                </Box>

                <Divider sx={{ mb: 4, borderColor: '#e2e8f0' }} />

                <Section title="1. Acceptance of Terms">
                    By accessing or using the SB2 school bus management platform ("Service"), you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the Service. These terms apply to all users including school administrators, parents, and drivers.
                </Section>

                <Section title="2. Description of Service">
                    SB2 provides a school bus management and tracking system that enables schools to manage routes, track buses in real time, and communicate with parents. The Service includes web and mobile applications for administrators, parents, and drivers.
                </Section>

                <Section title="3. User Accounts">
                    You are responsible for maintaining the confidentiality of your account credentials. You agree to notify the school administrator immediately of any unauthorized use of your account. Each user is responsible for all activity that occurs under their account. Accounts are non-transferable.
                </Section>

                <Section title="4. Acceptable Use">
                    You agree to use the Service only for its intended purpose of school bus management and communication. You must not: (a) use the Service for any unlawful purpose; (b) attempt to access systems or data you are not authorized to access; (c) interfere with the proper working of the Service; (d) transmit abusive, harassing, or offensive content.
                </Section>

                <Section title="5. Location Data">
                    Driver users consent to the collection of GPS location data while a route is active. This data is used solely to provide real-time bus tracking to parents and school staff. Location tracking is only active during assigned routes and stops automatically when a route is ended.
                </Section>

                <Section title="6. Children's Information">
                    Information about students (name, class, bus stop) is managed by the school and is used only to support bus routing and attendance. Parents may only access information about their own children. The school is responsible for ensuring appropriate consent for student data under applicable laws.
                </Section>

                <Section title="7. Intellectual Property">
                    The Service and all its content, features, and functionality are the property of SB2 and are protected by applicable intellectual property laws. You may not copy, modify, distribute, or reverse-engineer any part of the Service without explicit written permission.
                </Section>

                <Section title="8. Limitation of Liability">
                    SB2 is provided as a logistical aid and does not guarantee the safety, punctuality, or reliability of school bus services. The school administration is solely responsible for the safe operation of its bus fleet. We are not liable for any indirect, incidental, or consequential damages arising from use of the Service.
                </Section>

                <Section title="9. Service Availability">
                    We strive to maintain high availability but do not guarantee uninterrupted access. The Service may be temporarily unavailable due to maintenance, updates, or technical issues. We are not responsible for consequences of service unavailability.
                </Section>

                <Section title="10. Termination">
                    Accounts may be suspended or terminated by school administrators or by SB2 for violations of these terms. Upon termination, access to the Service will be revoked. User data may be retained for the period required by applicable law.
                </Section>

                <Section title="11. Changes to Terms">
                    We reserve the right to modify these terms at any time. Continued use of the Service after changes constitutes acceptance of the new terms. We will endeavor to notify users of significant changes through the application.
                </Section>

                <Section title="12. Governing Law">
                    These terms are governed by the laws of Greece and the European Union. Any disputes shall be resolved in the courts of competent jurisdiction in Greece.
                </Section>

                <Section title="13. Contact">
                    If you have questions about these Terms, please contact your school administrator or reach out through the application's messaging feature.
                </Section>

                <Divider sx={{ mb: 3, borderColor: '#e2e8f0' }} />

                <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                    <Link to="/privacy" style={{ color: AMBER, fontFamily: '"Outfit", sans-serif', fontSize: '0.9rem', fontWeight: 600, textDecoration: 'none' }}>
                        Privacy Policy →
                    </Link>
                    <Link to="/login" style={{ color: '#94a3b8', fontFamily: '"Outfit", sans-serif', fontSize: '0.9rem', textDecoration: 'none' }}>
                        ← Back to Login
                    </Link>
                </Box>
            </Box>
        </Container>
    </Box>
);

export default TermsPage;
